import { Outlet } from 'react-router-dom'

import { TicketingPoliciesDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useQuery } from 'modules/core/hooks/useQuery'

const RootPage = () => {
  const { data, loading } = useQuery(TicketingPoliciesDocument)

  if (loading) return <Loading />
  if (!data?.ticketing._policies.viewTicketingSettings.can) return <NotFound />

  return <Outlet />
}

export default RootPage
